.invisible {
  max-height: 28px;
  visibility: hidden;
}
